<template>
  <div class="new-field">
    <el-form :model="fieldData" ref="fieldData" label-width="200px" class="new-field-form">
      
      <el-form-item label="Name" prop="field_name">
        <el-input v-model="fieldData.field_name"></el-input>
      </el-form-item>

      <el-form-item label="Field Type" prop="type_id">
        <el-select v-model="fieldData.type_id" placeholder="Field Type">
          <el-option v-for="f_type in types"
            :key="f_type.id"
            :value="f_type.id"
            :label="f_type.name">
          </el-option>
        </el-select>  
      </el-form-item>

      <el-form-item label="Light Type" prop="light_type_id">
        <el-select v-model="fieldData.light_type_id" placeholder="Light Type">
          <el-option label="LED Switchbox" value="1"></el-option>
          <el-option label="LED AAA-Lux" value="2"></el-option>
          <el-option label="Metal Halide" value="3"></el-option>
        </el-select>  
      </el-form-item>
      
      <el-form-item label="Restrike Time (Minutes)" prop="min_off_time">
        <el-input v-model="fieldData.min_off_time"></el-input>
      </el-form-item>
      
      <el-form-item label="Power Relay" prop="power_relay" style="align: left;">
        <el-select v-model="fieldData.power_relay" placeholder="Power Relay">
          <el-option 
              v-for="device in devices"
              :key="device.id"
              :label="device.name"
              :value="device.id">
          </el-option>
        </el-select>
      </el-form-item>
      <div v-if="fieldData.power_relay > 0">
        <el-form-item label="Logical" style="align: left;">
          <el-select v-model="fieldData.logical_no" placeholder="Logical no">
            <el-option 
              v-for="logical in logicals"
              :key="logical.logical_no"
              :label="logical.logical_no"
              :value="logical.logical_no">
          </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Delay (Seconds)" prop="delay">
          <el-input-number v-model="fieldData.delay"></el-input-number>
        </el-form-item>
      </div>

      <el-form-item label="Interface" prop="interface_id">
        <el-select v-model="fieldData.interface_id" placeholder="Interface">
            <el-option 
              v-for="inter in interfaces" 
              :key="inter.id"
              :label="inter.name"
              :value="inter.id">
            </el-option>
        </el-select>
      </el-form-item>
      <div v-show="fieldData.interface_id > 0">
        <el-form-item label="Lights">
          <el-select
            v-model="fieldData.lights"
            multiple
            filterable
            allow-create
            placeholder="Enter new MAC or choose from list"
            style="width: 65%;"
            value-key="mac"
            @change="macInputChanged">
            <el-option 
              v-for="light in lights" 
              :key="light.id" 
              :label="light.mac"
              :value="light">
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <el-form-item>
        <el-button type="save" @click="submit('fieldData')">Create</el-button>
        <el-button type="cancel" @click="close">Cancel</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import auth from '../../../auth';
import requests from '../../../requests';

export default {
  name: 'admin-new-field',
  props: ['fieldData', 'siteId'],
  data () {
    return {
      pageName: 'New Field',
      devices:[],
      logicals:[],
      types: [],
      interfaces: [],
      lights: [],
      userIsSuperAdmin: false,
    }
  },
  methods: {
    newField(){

      this.fieldData.site_id = this.siteId;

      var fieldData = this.fieldData;
      if(!fieldData.interface_id || fieldData.interface_id < 0) { fieldData.interface_id = null };

      var context = this;

      requests.newField(this, fieldData, function (result) {
        if(result.action === 'success'){
          context.$message({
            showClose: true,
            type: 'success',
            message: 'Successfully created field'
          });

          var lightData = context.fieldData.lights;
          var lights = context.lights;

          var remLights = lights.filter((v) => {
            return lightData.indexOf(v) < 0;
          });

          for (var i = 0; i < remLights.length; i++) {
            var light = remLights[i];
            light.field_id = null;
            requests.updateLight(context, light.id, light, function(result) {});
          }

          var num = 0;

          for (var i = 0; i < lightData.length; i++) {
            var light = lightData[i];

            if(typeof(light) == 'object') {
              // light = JSON.parse(light);
              light.field_id = field_id;

              requests.updateLight(context, light.id, light, function (result) {});

            } else {

              var kInd = findKey(context.lights, {mac: light});
              if(kInd) {
                requests.getLightFromMAC(context, light, function (result) {
                  light = result.data;
                  light.field_id = field_id;
                  requests.updateLight(context, light.id, light, function (result) {});                  
                })

              } else {
                light = { num: '', mac: light, field_id: field_id }

                if( num == 0) {
                  //Get the highest num in lights + 1
                  if(lights && lights.length > 0) {
                    var lightNum = Math.max(...lights.map(o => o.num), null);
                    if(lightNum) {
                      num = lightNum + 1;
                    } else { // If that errors, 1 longer than length
                      num = lights.length + 1;
                    }
                  } else {
                    num = 1;
                  }
                } else {
                  num++;
                }

                light.num = num;

                requests.newLight(context, light, function(result) {});
              }
            }
          }
          context.close();

        } else {

          context.$message({
            showClose: true,
            type: 'error',
            message: 'Failed to create new field: ' + result.msg,
          });
        }
      });

    },
    submit(formName) {
      // console.log(this.userData);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.newField();
          this.reset(formName);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
    },
    close() {
      this.reset('fieldData');
      this.$emit('close');
    },
    macInputChanged(val) {

      for (var i = 0; i < val.length; i++) {
        var v = val[i];
        if(typeof(v) === 'string') {
          var bits = v.replace(/ /g, '').split(',');
          val[i] = bits[0];
          for (var j = 1; j < bits.length; j++) {
            val.push(bits[j]);
          }
        }
      }
    },
  },
  beforeMount() {
    var context = this;
    var profile = JSON.parse(auth.getProfile());
    this.userIsSuperAdmin = (profile.role === 3);

    for (var key in this.fieldData) {
      if (this.fieldData.hasOwnProperty(key)) {
        var el = this.fieldData[key];
        if(typeof(el) == 'object') {
          this.fieldData[key] = []
        } else if(typeof(el) == 'number') {
          if(key == 'delay')
            this.fieldData[key] = 10;
          else 
            this.fieldData[key] = 0;
        } else {
          this.fieldData[key] = '';
        }
      }
    }
    
    requests.getRelayDevices(this, function(result){
      context.devices = result.data;
      context.devices.push({id: -1, name:'None'});
      context.fieldData.power_relay = -1; //Default to None
    });

    requests.getFieldTypes(this, function(result){
      context.types = result.data;
    });

    requests.getInterfaceDevices(this, function(result){
      context.interfaces = result.data;
      context.interfaces.push({id: -1, name:'None'});
      context.fieldData.interface_id = -1;
    });

    requests.getLightsAtFieldOrNull(this, -1, function(result) {
      var lights = result.data;
      for (var i = 0; i < lights.length; i++) {
        var light = lights[i];
        if(light.field_id) {
          context.fieldData.lights.push(light);
        }
      }
      context.lights = lights;
    });

    requests.getFields(this, context.siteId, function(result){
      if(result.action === 'success') {
        var fields = result.data;
        // Get highest field_no in fields array
        if(fields && fields.length > 0) {
          var fieldNum = Math.max(...fields.map(o => o.field_no), null);
          if(fieldNum) {
            context.fieldData.field_no = fieldNum + 1;
          } else { // If that errors, 1 longer than length
            context.fieldData.field_no = fields.length + 1;
          }
        } else {
          context.fieldData.field_no = 1;
        }
      } else {
        context.$message({
          type: 'error',
          message: 'Failed to recieve fields: ' + result.msg
        });
      }
    });
  },
  watch: {
    'fieldData.power_relay':function(val){
      if(!val || val < 1){
        return false;
      }
      var context = this;
      requests.getDeviceRelays(this, val, function(result){
        context.logicals = result.data;
      });
    },
    'fieldData.light_type_id':function(val){
      if(val == 3 && this.fieldData.min_off_time == 0) {
        this.fieldData.min_off_time = 30;
      }
    }
  }
}
</script>

<style>
  
  .separator {
    border-bottom: 1px #dddddd solid;
    margin-bottom: 20px;
  }
  
</style>



// WEBPACK FOOTER //
// NewField.vue?4184f916